import React from 'react';
import PropTypes from 'prop-types';
import { DocumentCheck } from 'components/HealthRecords/Documents/DocumentCheck';
import DocumentBadge from 'components/HealthRecords/Documents/DocumentBadge';
import PrescriptionBadge from 'components/HealthRecords/Prescriptions/PrescriptionBadge';
import ReceiptBadge from 'components/Payments/ReceiptList/ReceiptBadge';
import './style.scss';

/**
 * SelectableDocumentBadge - Renders a document/prescription/receipt badge with a checkbox
 *
 * Provides a consistent layout with checkbox on the left and badge on the right.
 * Automatically selects the correct badge component based on the document type.
 */
export const SelectableDocumentBadge = ({
  document,
  isChecked,
  onToggle,
  index,
  showOrder = true,
  patient,
}) => {
  // Determine badge type based on document properties
  const isDocument = !!document.filename;
  const isPrescription = !document.filename && !!document.attachments;
  const isReceipt = !!document.receipt_url;

  return (
    <div className="document-list-item">
      <div className="checkbox-container">
        <DocumentCheck
          document={document}
          isChecked={isChecked}
          toggleDocument={onToggle}
          documentIndex={index}
          tooltip={
            showOrder
              ? 'The documents will be sent in the order indicated by this number'
              : undefined
          }
        />
      </div>
      <div className="badge-container">
        {isDocument && <DocumentBadge item={document} key={document.id} />}
        {isPrescription && <PrescriptionBadge item={document} key={document.id} />}
        {isReceipt && <ReceiptBadge receipt={document} key={document.id} patient={patient} />}
      </div>
    </div>
  );
};

SelectableDocumentBadge.propTypes = {
  document: PropTypes.object.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  showOrder: PropTypes.bool,
  patient: PropTypes.object, // Required only for receipts
};

export default SelectableDocumentBadge;
